module.exports = __webpack_public_path__ + "static/media/voix2.99df7752.ogg";